import {SelectionItem} from "../selections/selection-item";

export class ScheduleSharingData {

  user!: string;
  scheduleId!: string;
  organizations!: SelectionItem[];
  officeLabel!: string;
  userLabel!: string;
  notificationLabel!: string;

}
